// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import axios from 'axios';
// import Select from 'react-select';
// import { Offcanvas } from 'react-bootstrap';
// import OrganisationModal from '../organisation/OrganisationModal';
// import CreatableSelect from 'react-select/creatable';
// import { FaPlus } from "react-icons/fa";
// import ProductForm from '../../product/ProductForm';
// import { useLocation } from 'react-router-dom';
// import dayjs from "dayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// const DealModal = ({
//     showModal,
//     handleClose,
//     dealId,
//     dealData,
//     addDeal,
//     editDeal,
//     deals,
//     organisations,
//     fetchOrganisation,
//     setOrganisation,
//     revenueType,
//     isSalesOrderList

// }) => {
//     const [formData, setFormData] = useState({
//         organisation_id: '',
//         stage: '',
//         name: '',
//         value: '',
//         expected_revenue: '',
//         closed_date: '',
//         probability: '',
//         lead_source: '',
//         next_steps: '',
//         customer_type: '',
//         remarks: '',
//         partner_name: '',
//         partner_id: '',
//         products: [],
//         type_id: '',
//         subscription_start_date: '',
//         vendor_subscription_end_dates: '',
//         subscription_due_date: '',
//         deployment_start_date: '',
//         deployment_end_date: '',
//         brand_id: [],
//         assigned_to: '',
//         WHT: '',
//         payment_term: '',
//     });
//     const [activeTab, setActiveTab] = useState(0);
//     const [allProducts, setAllProducts] = useState([]);
//     const [partners, setPartner] = useState([]);
//     const [showOrgModal, setShowOrgModal] = useState(false);
//     const [showProductModal, setShowProductModal] = useState(false);
//     const [isLeadModalHidden, setIsLeadModalHidden] = useState(false);
//     const [industries, setIndustries] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
//     const [brands, setBrands] = useState([]);
//     const [vendors, setVendors] = useState({ allVendors: [] });
//     const [contacts, setContacts] = useState([]);
//     const [users, setUsers] = useState([]);
//     const [showBrandModal, setShowBrandModal] = useState(false);
//     const location = useLocation();

//     // Check if we're on the /orders page
//     const isOrdersPage =
//         location.pathname === '/orders' ||
//         location.pathname.startsWith(`/deal/details/${dealId}`) || isSalesOrderList;

//     const fetchIndustries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             let allIndustries = [];
//             let currentPage = 1;
//             let lastPage = 1;


//             const response = await axios.get(`${backendUrl}/api/industries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,

//             });

//             allIndustries = [...allIndustries, ...response.data.industry]


//             setIndustries(allIndustries);
//         } catch (error) {
//             console.error('Error fetching industries:', error);
//         }
//     };
//     const fetchContacts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             const response = await axios.get(`${backendUrl}/api/contact`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             // const filteredContacts = response.data.Data.filter(
//             //     contact => contact.type !== "instance" && contact.type !== "tenant"
//             // );

//             setContacts(response.data.Data);

//         } catch (error) {
//             console.error('Error fetching contacts:', error);
//         }
//     };

//     const fetchProducts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/products`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });


//             if (Array.isArray(response.data.Data)) {
//                 setAllProducts(response.data.Data);
//             } else {
//                 console.error("Invalid response format", response.data);
//             }

//         } catch (error) {
//             console.error('Error fetching instances:', error);
//         }
//     };
//     const fetchCategories = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allCategories = [];

//             const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             allCategories = [...allCategories, ...response.data.category];

//             const allCategoriesList = allCategories.filter(cat => !cat.parent_id);

//             // All subcategories (categories with parent_id)
//             const allSubcategories = allCategories.filter(cat => cat.parent_id);

//             setCategories({ allCategoriesList, allSubcategories });
//         } catch (error) {
//             console.error('Error fetching categories:', error);
//         }
//     };

//     const fetchUsers = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/users`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const userOptions = response.data.users.map(user => ({
//                 value: user.id,
//                 label: `${user.name} (${user.roles?.map(r => r.name).join(', ') || 'No Role'})`
//             }));

//             setUsers(userOptions);
//         } catch (error) {
//             console.error('Error fetching users:', error);
//         }
//     };

//     const fetchBrands = async () => {
//         console.log("⚙️ Fetching brands...");
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/brands`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });
//             console.log("Brand API response:", response.data);

//             // const data = response.data?.brand;
//             // console.log("Brand API response:", data);
//             let brandsData = response.data?.brand || response.data?.data || response.data;

//             // Ensure it's always an array
//             if (!Array.isArray(brandsData)) {
//                 // If it's an object with a results/data property, use that
//                 brandsData = brandsData?.results || brandsData?.data || [];
//             }



//             console.log("Processed brands data:", brandsData);
//             setBrands(brandsData);
//         } catch (error) {
//             console.error('Error fetching brands:', error);
//             setBrands([]); // Set empty array on error
//         }
//     };
//     const fetchVendors = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             let allVendors = [];

//             const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,

//             });

//             // const { data, current_page, last_page } = response.data.Data;
//             allVendors = [...allVendors, ...response.data.Data];

//             setVendors({ allVendors });

//         } catch (error) {
//             console.error(`Error fetching vendors:`, error);
//         }
//     };

//     useEffect(() => {
//         if (showModal) {

//             // fetchProducts();
//             fetchBrands();
//         }
//     }, [showModal]);
//     const [filteredContacts, setFilteredContacts] = useState([]);

//     const handleOrgModalClose = (newOrg) => {
//         setShowOrgModal(false);

//         if (newOrg) {
//             setAllProducts((prev) => [...prev, newOrg]); // Add new org to the list

//             // Ensure formData is updated with the new org ID
//             setFormData((prev) => ({
//                 ...prev,
//                 organisation_id: newOrg.id,
//                 contact_id: ''
//             }));

//         }
//         setIsLeadModalHidden(false);
//     };
//     const handleProductModalClose = (newProduct) => {
//         setShowProductModal(false);

//         if (newProduct) {
//             setAllProducts((prev) => [...prev, newProduct]);
//             setFormData((prev) => ({
//                 ...prev,
//                 products: [...prev.products, { product_id: newProduct.id, item_name: newProduct.product_name, quantity: 1, price: newProduct?.product?.selling_price }],
//             }));
//         }
//         setIsLeadModalHidden(false);
//     };
//     const handleBrandModalClose = (newProduct) => {
//         setShowProductModal(false);

//         if (newProduct) {
//             setAllProducts((prev) => [...prev, newProduct]);
//             setFormData((prev) => ({
//                 ...prev,
//                 products: [...prev.products, { product_id: newProduct.id, item_name: newProduct.product_name, quantity: 1, price: newProduct?.product?.selling_price }],
//             }));
//         }
//         setIsLeadModalHidden(false);
//     };
//     const addProducts = async (newProduct) => {
//         try {
//             const formData = new FormData();
//             // Append regular fields
//             Object.keys(newProduct).forEach((key) => {
//                 formData.append(key, newProduct[key]);
//             });

//             if (newProduct.product_image) {
//                 formData.append('product_image', newProduct.avatar);
//             }
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             // Corrected API endpoint with dynamic contact_type for adding
//             const response = await axios.post(`${backendUrl}/api/products`, formData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,


//                 },
//             });
//             const createdProduct = response.data.Data;

//             if (createdProduct) {
//                 setAllProducts((prevProducts) => [...prevProducts, createdProduct]);
//                 setFormData((prev) => ({
//                     ...prev,
//                     products: [...prev.products, { product_id: createdProduct.id, item_name: createdProduct.product_name, item_description: createdProduct.description, quantity: 1, price: createdProduct.product?.selling_price }],
//                 }));
//                 setShowProductModal(false);
//             } else {
//                 console.error('Creation failed, no data returned.');
//             }

//             setShowProductModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {
//                 console.error(`Error adding organisation`, error);
//             }
//         }
//     };
//     const addOrganisation = async (newOrganisation) => {
//         try {
//             const formData = new FormData();
//             // Append regular fields
//             Object.keys(newOrganisation).forEach((key) => {
//                 formData.append(key, newOrganisation[key]);
//             });


//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             // Corrected API endpoint with dynamic contact_type for adding
//             const response = await axios.post(`${backendUrl}/api/organisation`, formData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             const createdOrganisation = response.data.data;

//             if (createdOrganisation) {
//                 setOrganisation((prevOrganisation) => [...prevOrganisation, createdOrganisation]);
//                 setFormData(prev => ({ ...prev, organisation_id: createdOrganisation.id }));
//                 // return createdOrganisation; 
//             } else {
//                 console.error('Creation failed, no data returned.');
//             }

//             setShowOrgModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {
//                 console.error(`Error adding organisation`, error);
//             }
//         }
//     };

//     useEffect(() => {
//         if (showModal && organisations?.length === 0) {
//             fetchOrganisation();
//         }
//         if (showModal && contacts?.length === 0) {
//             fetchContacts();
//         }
//         if (showModal && users?.length === 0) {
//             fetchUsers();
//         }
//         if (showModal && !dealData) {
//             // Reset formData for new orgs creation
//             setFormData({
//                 organisation_id: '',
//                 stage: '',
//                 name: '',
//                 value: '',
//                 closed_date: '',
//                 probability: '',
//                 expected_revenue: '',
//                 lead_source: '',
//                 next_steps: '',
//                 customer_type: '',
//                 remarks: '',
//                 partner_name: '',
//                 partner_id: '',
//                 products: [],
//                 type_id: '',
//                 subscription_start_date: '',
//                 vendor_subscription_end_dates: '',
//                 subscription_due_date: '',
//                 deployment_start_date: '',
//                 deployment_end_date: '',
//                 brand_id: [],
//                 assigned_to: '',
//             });
//         } else if (dealData) {
//             setFormData({
//                 organisation_id: dealData.organisation_id || dealData.client_id || '',
//                 stage: dealData.stage || '',
//                 value: dealData.value || '',
//                 closed_date: dealData.closed_date || '',

//                 probability: dealData.probability !== undefined ? dealData.probability : getProbability(dealData.stage),
//                 name: dealData.name || '',
//                 expected_revenue: dealData.expected_revenue || '',
//                 lead_source: dealData.lead_source || '',
//                 next_steps: dealData.next_steps || '',
//                 customer_type: dealData.customer_type || '',
//                 remarks: dealData.remarks || '',
//                 partner_name: dealData.partner_name || '',
//                 partner_id: dealData.partner_id || '',
//                 type_id: dealData.type_id || '',
//                 subscription_start_date: dealData?.quotation?.project?.subscription_start_date || '',
//                 vendor_subscription_end_dates: dealData?.quotation?.project?.vendor_subscription_end_dates || '',
//                 subscription_due_date: dealData?.quotation?.project?.subscription_due_date || '',
//                 // Add payment_term from dealData if it exists
//                 payment_term: dealData?.quotation?.project?.payment_term || '',
//                 deployment_start_date: dealData?.quotation?.project?.deployment_start_date || '',
//                 deployment_end_date: dealData?.quotation?.project?.deployment_end_date || '',
//                 brand_id: dealData.brand_id
//                     ? (Array.isArray(dealData.brand_id)
//                         ? dealData.brand_id
//                         : JSON.parse(dealData.brand_id || '[]')).map(id => parseInt(id))
//                     : [],
//                 assigned_to: dealData.assigned_to || '',
//                 products: Array.isArray(dealData.product_item_details) // Match the backend key exactly
//                     ? dealData.product_item_details.map(p => ({
//                         product_id: p.product_id, // Assuming the product ID is under 'id'
//                         item_name: p.item_name || p.product_name,
//                         quantity: p.quantity || 1,
//                         price: p.price || 0
//                     }))
//                     : [],
//                 WHT: dealData.WHT || '',

//             });

//         }
//     }, [dealData, showModal, contacts]);

//     const handleProductChange = (selectedOptions) => {
//         setFormData(prevFormData => ({
//             ...prevFormData,
//             products: selectedOptions.map(option => ({
//                 product_id: option.value,  // Ensure correct ID
//                 item_name: option.label,
//                 item_description: allProducts.find(p => p.id === option.value)?.description || '',
//                 quantity: 1,
//                 price: 0
//             }))
//         }));
//     };


//     const productOptions = allProducts.map(product => ({
//         value: product.id,
//         label: product.product_name
//     }));



//     const removeProduct = (productId) => {
//         setFormData(prevFormData => ({
//             ...prevFormData,
//             products: prevFormData.products.filter(product => product.product_id !== productId)
//         }));
//     };


//     const getProbability = (stage) => {
//         const probabilities = {
//             suspect: 10,
//             prospect: 25,
//             approach: 50,
//             negotiation: 75,
//             "closed won": 90,
//             "closed lost": 0,
//             "closed dead": 0,
//             order: 100
//         };
//         return probabilities[stage] || '';
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         let newFormData = { ...formData, [name]: value };

//         if (name === "stage") {
//             // Update probability when stage changes
//             const newProbability = getProbability(value);
//             newFormData.probability = newProbability;
//         }

//         if (name === "value" || name === "stage") {
//             // Recalculate expected revenue when value or stage changes
//             const numericValue = parseFloat(newFormData.value) || 0;
//             const numericProbability = parseFloat(newFormData.probability) || 0;
//             newFormData.expected_revenue = (numericValue * numericProbability) / 100;
//         }

//         setFormData(newFormData);
//         if (errors[name]) {
//             setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
//         }
//     };

//     const handleDateChange = (name, date) => {
//         setFormData(prev => ({
//             ...prev,
//             [name]: date ? dayjs(date).format('YYYY-MM-DD') : ''
//         }));
//         if (errors[name]) {
//             setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
//         }
//     };




//     useEffect(() => {
//         if (!showModal) {
//             setErrors({});
//         }
//     }, [showModal]);

//     const validateForm = () => {
//         const newErrors = {};
//         if (!formData.name) newErrors.name = 'Name is required';
//         if (formData.stage === 'negotiation' && (!dealData || !dealData.quotation_id)) {
//             newErrors.stage = 'Cannot select Negotiation stage without a quotation. Please create a quotation first.';
//         }

//         return newErrors;
//     };
//     const [loading, setLoading] = useState(false);


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const validationErrors = validateForm();
//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             setLoading(false);
//             return; // Stop here if validation fails
//         }
//         const updatedFormData = {
//             ...formData,
//             ...(isSalesOrderList ? { client_id: formData.organisation_id } : {}),
//             products: formData.products.map(p => ({
//                 product_id: p.product_id,
//                 quantity: p.quantity,
//                 price: p.price,
//                 item_name: p.item_name,
//                 item_description: p.item_description
//             }))
//         };
//         let errors;
//         if (dealData && dealData.id) {
//             errors = await editDeal(dealData.id, updatedFormData);
//         } else {
//             errors = await addDeal(updatedFormData);
//         }

//         if (errors && Object.keys(errors).length > 0) {
//             setErrors(errors); // Display validation errors
//         } else {
//             setErrors({}); // Clear errors on success
//             handleClose(); // Close modal on success
//         }
//     };
//     const partnerOrganisations = organisations?.filter(org => org.org_type === 'partner');
//     useEffect(() => {
//         const leadSource = formData.lead_source?.toLowerCase();

//         if (leadSource === 'partner' && formData.partner_id) {
//             const partnerOrganisation = organisations.find(
//                 (org) => String(org.id) === String(formData.partner_id)
//             );

//             if (partnerOrganisation?.org_type?.toLowerCase() === 'partner') {
//                 setFilteredContacts(partnerOrganisation.contacts || []);
//             }
//         } else if (['consultant', 'inside sales', 'sales generated'].includes(leadSource)) {
//             const typeNameMap = {
//                 consultant: 'consultant',
//                 'inside sales': 'inside sales',
//                 'sales generated': 'sales generated'
//             };

//             setFilteredContacts(
//                 (contacts || []).filter(contact =>  // ✅ Prevents undefined error
//                     contact.contact_type?.toLowerCase() ===
//                     (leadSource === 'consultant' ? 'external' : 'internal') &&
//                     contact.type_id &&
//                     (contact.type?.name?.toLowerCase() === typeNameMap[leadSource])
//                 )
//             );

//         } else {
//             const selectedOrg = organisations.find(
//                 (org) => String(org.id) === String(formData.organisation_id)
//             );
//             setFilteredContacts(selectedOrg?.contacts || []);
//         }
//     }, [organisations, formData.organisation_id, formData.partner_id, contacts, formData.lead_source]);
//     const isEditMode = Boolean(dealId); // true if editing
//     const isLimitedEdit =
//         isEditMode && (revenueType === "subscription" || revenueType === "deployment");
//     const commonFieldStyles = {
//         border: '0.5px solid rgb(232, 233, 237)',
//         borderRadius: '14px',
//         height: '39px',
//         fontSize: '13px',
//     };

//     return (

//         <div>
//             <div>
//                 {showModal && (
//                     <div
//                         className="project-modal-backdrop"
//                         style={{
//                             position: 'fixed',
//                             top: 0,
//                             left: 0,
//                             width: '100%',
//                             height: '100%',
//                             backgroundColor: 'rgba(255, 255, 255, 0.2)', // light white transparent
//                             zIndex: 1048, // ✅ keep it below the modal backdrop (Bootstrap's 1050)
//                             pointerEvents: 'none', // ✅ prevent blocking modal clicks
//                             backdropFilter: 'blur(2px)',
//                             WebkitBackdropFilter: 'blur(2px)',
//                             transition: 'opacity 0.3s ease',
//                         }}
//                     />
//                 )}
//             </div>



//             {showModal && !isLeadModalHidden && (

//                 <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '650px' }} backdrop="static">
//                     <Offcanvas.Header closeButton>
//                         <Offcanvas.Title>
//                             {dealId ? 'Edit' : 'Add'}
//                         </Offcanvas.Title>
//                     </Offcanvas.Header>
//                     <hr style={{ margin: 0 }} /><br />


//                     <Offcanvas.Body>
//                         <form onSubmit={handleSubmit}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <div className="row">
//                                     {isSalesOrderList ? (
//                                         <div className="col-12 px-3">
//                                             {/* Basic Details Section */}
//                                             <div className="mb-4">
//                                                 <h6 className="fw-semibold text-primary mb-3" style={{ borderBottom: '1px solid #eee', paddingBottom: '8px' }}>Basic Details</h6>
//                                                 <div className="row">
//                                                     <div className="col-md-6">
//                                                         <div className="form-group mb-3">
//                                                             <label htmlFor="name" className="form-label" style={{ fontSize: '13px' }}>Project Name</label>
//                                                             <input
//                                                                 name="name" id="name" type="text" value={formData.name} onChange={handleChange}
//                                                                 className={`form-control form-feild ${errors?.name ? 'is-invalid' : ''}`}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-md-6">
//                                                         <div className="form-group mb-3">
//                                                             <label htmlFor="organisation_id" className="form-label" style={{ fontSize: '13px' }}>Client Name</label>
//                                                             <CreatableSelect
//                                                                 isClearable
//                                                                 options={organisations.map(org => ({
//                                                                     value: org.id,
//                                                                     label: org.name || org.company_name || `${org.first_name || ""} ${org.last_name || ""}`.trim() || `Client ${org.id}`
//                                                                 }))}
//                                                                 value={
//                                                                     formData.organisation_id
//                                                                         ? {
//                                                                             value: formData.organisation_id,
//                                                                             label: (organisations.find(org => String(org.id) === String(formData.organisation_id))?.name ||
//                                                                                 organisations.find(org => String(org.id) === String(formData.organisation_id))?.company_name ||
//                                                                                 organisations.find(org => String(org.id) === String(formData.organisation_id))?.first_name ||
//                                                                                 dealData?.client?.name || dealData?.quotation?.project?.client?.name || "")
//                                                                         }
//                                                                         : null
//                                                                 }
//                                                                 onChange={(newValue) => {
//                                                                     setFormData(prev => ({ ...prev, organisation_id: newValue ? newValue.value : "" }));
//                                                                 }}
//                                                                 styles={{
//                                                                     control: (base) => ({
//                                                                         ...base,
//                                                                         fontSize: '13px',
//                                                                         borderRadius: '14px',
//                                                                         height: '39px',
//                                                                         minHeight: '39px',
//                                                                         border: '0.5px solid rgb(232, 233, 237)'
//                                                                     }),
//                                                                     menu: (base) => ({
//                                                                         ...base,
//                                                                         fontSize: '13px'
//                                                                     })
//                                                                 }}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-md-6">
//                                                         <div className="form-group mb-3">
//                                                             <label htmlFor="stage" className="form-label" style={{ fontSize: '13px' }}>Stage</label>
//                                                             <select
//                                                                 style={{ border: '0.5px solid rgb(232, 233, 237)' }}
//                                                                 name="stage" id="stage" className={`form-control form-feild ${errors?.stage ? 'is-invalid' : ''}`}
//                                                                 value={formData.stage} onChange={handleChange}
//                                                             >
//                                                                 <option value="">Select</option>
//                                                                 <option value="approach">Approach</option>
//                                                                 <option value="negotiation">Negotiation</option>
//                                                                 <option value="closed won">Closed Won</option>
//                                                                 <option value="order">Order</option>
//                                                             </select>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-md-6">
//                                                         <div className="form-group mb-3">
//                                                             <label htmlFor="value" className="form-label" style={{ fontSize: '13px' }}>Value</label>
//                                                             <input
//                                                                 name="value" id="value" className='form-control form-feild' value={formData.value} onChange={handleChange}
//                                                                 style={{ border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-md-6">
//                                                         <div className="form-group mb-3">
//                                                             <label htmlFor="WHT" className="form-label" style={{ fontSize: "13px" }}>WHT(%)</label>
//                                                             <input
//                                                                 type="text" name="WHT" className="form-control form-feild" value={formData.WHT} onChange={handleChange}
//                                                                 style={{ border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                             />
//                                                         </div>
//                                                     </div>


//                                                 </div>
//                                             </div>

//                                             {/* Subscription Details Section */}
//                                             <div className="mb-4">
//                                                 <h6 className="fw-semibold text-primary mb-3" style={{ borderBottom: '1px solid #eee', paddingBottom: '8px' }}>Subscription Details</h6>
//                                                 <div className="row">
//                                                     <div className="col-md-6">
//                                                         <div className="form-group mb-3">
//                                                             <label htmlFor="payment_term" className="form-label" style={{ fontSize: "13px" }}>Payment Term</label>
//                                                             <select
//                                                                 name="payment_term" className="form-control form-feild" value={formData.payment_term} onChange={handleChange}
//                                                                 style={{ border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                             >
//                                                                 <option value="">Select</option>
//                                                                 <option value="yearly">Yearly</option>
//                                                                 <option value="half-yearly">Half Yearly</option>
//                                                                 <option value="quarterly">Quarterly</option>
//                                                                 <option value="custom">Custom</option>
//                                                             </select>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-md-6">
//                                                         <div className="form-group mb-3">
//                                                             <label htmlFor="subscription_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>




//                                                             <div className="datepicker-wrapper w-280">
//                                                                 <DatePicker
//                                                                     format="DD-MM-YYYY"
//                                                                     value={formData.subscription_start_date ? dayjs(formData.subscription_start_date) : null}
//                                                                     onChange={(date) => handleDateChange('subscription_start_date', date)}
//                                                                     slotProps={{
//                                                                         textField: {
//                                                                             fullWidth: true,
//                                                                             size: "small",
//                                                                             sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                         }
//                                                                     }}
//                                                                 />
//                                                             </div>
//                                                             <div className="col-md-6">
//                                                                 <div className="form-group mb-3">
//                                                                     <label htmlFor="vendor_subscription_end_dates" className="form-label d-block" style={{ fontSize: "13px" }}>End Date</label>

//                                                                     <div className="datepicker-wrapper w-280">
//                                                                         <DatePicker
//                                                                             format="DD-MM-YYYY"
//                                                                             value={formData.vendor_subscription_end_dates ? dayjs(formData.vendor_subscription_end_dates) : null}
//                                                                             onChange={(date) => handleDateChange('vendor_subscription_end_dates', date)}
//                                                                             slotProps={{
//                                                                                 textField: {
//                                                                                     fullWidth: true,
//                                                                                     size: "small",
//                                                                                     sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                 }
//                                                                             }}
//                                                                         />
//                                                                     </div>
//                                                                     </div>
//                                                                     </div>
//                                                                     <div className="col-md-6">
//                                                                         <div className="form-group mb-3">
//                                                                             <label htmlFor="subscription_due_date" className="form-label d-block" style={{ fontSize: "13px" }}>Due Date</label>

//                                                                             <div className="datepicker-wrapper w-280">
//                                                                                 <DatePicker
//                                                                                     format="DD-MM-YYYY"
//                                                                                     value={formData.subscription_due_date ? dayjs(formData.subscription_due_date) : null}
//                                                                                     onChange={(date) => handleDateChange('subscription_due_date', date)}
//                                                                                     slotProps={{
//                                                                                         textField: {
//                                                                                             fullWidth: true,
//                                                                                             size: "small",
//                                                                                             sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                         }
//                                                                                     }}
//                                                                                 />
//                                                                             </div>
//                                                                         </div>
//                                                                     </div>

//                                                                             {/* Deployment Details Section */}
//                                                                             <div className="mb-4">
//                                                                                 <h6 className="fw-semibold text-primary mb-3" style={{ borderBottom: '1px solid #eee', paddingBottom: '8px' }}>Deployment Details</h6>
//                                                                                 <div className="row">
//                                                                                     <div className="col-md-6">
//                                                                                         <div className="form-group mb-3">
//                                                                                             <label htmlFor="deployment_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>

//                                                                                             <div className="datepicker-wrapper w-280">
//                                                                                                 <DatePicker
//                                                                                                     format="DD-MM-YYYY"
//                                                                                                     value={formData.deployment_start_date ? dayjs(formData.deployment_start_date) : null}
//                                                                                                     onChange={(date) => handleDateChange('deployment_start_date', date)}
//                                                                                                     slotProps={{
//                                                                                                         textField: {
//                                                                                                             fullWidth: true,
//                                                                                                             size: "small",
//                                                                                                             sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                         }
//                                                                                                     }}
//                                                                                                 />
//                                                                                             </div>
//                                                                                         </div>
//                                                                                     </div>

//                                                                                             <div className="col-md-6">
//                                                                                                 <div className="form-group mb-3">
//                                                                                                     <label htmlFor="deployment_end_date" className="form-label d-block" style={{ fontSize: "13px" }}>Deployment End</label>

//                                                                                                     <div className="datepicker-wrapper w-280">
//                                                                                                         <DatePicker
//                                                                                                             format="DD-MM-YYYY"
//                                                                                                             value={formData.deployment_end_date ? dayjs(formData.deployment_end_date) : null}
//                                                                                                             onChange={(date) => handleDateChange('deployment_end_date', date)}
//                                                                                                             slotProps={{
//                                                                                                                 textField: {
//                                                                                                                     fullWidth: true,
//                                                                                                                     size: "small",
//                                                                                                                     sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                                 }
//                                                                                                             }}
//                                                                                                         />
//                                                                                                     </div>
//                                                                                                 </div>
//                                                                                             </div>
//                                                                                                     ) : (
//                                         <>
//                                                                                                         {/* Example Input Field */}
//                                                                                                         <div className="col-md-6">
//                                                                                                             <div className="form-group mb-3">
//                                                                                                                 <label htmlFor="name" className="form-label" style={{ fontSize: '13px' }}>{isSalesOrderList ? 'Project Name' : 'Name'}</label>
//                                                                                                                 <input
//                                                                                                                     style={{
//                                                                                                                         maxWidth: '280px',
//                                                                                                                         border: '0.5px solid rgb(232, 233, 237)',
//                                                                                                                         borderRadius: '14px',
//                                                                                                                         ...(isLimitedEdit
//                                                                                                                             ? { backgroundColor: "#ffffff", cursor: "not-allowed" }
//                                                                                                                             : {})
//                                                                                                                     }}
//                                                                                                                     name="name"
//                                                                                                                     id="name"
//                                                                                                                     type="text"
//                                                                                                                     value={formData.name}
//                                                                                                                     onChange={handleChange}
//                                                                                                                     className={`form-control form-feild ${errors?.name ? 'is-invalid' : ''}`}
//                                                                                                                 />

//                                                                                                                 {errors.name && (
//                                                                                                                     <div className="invalid-feedback" style={{ fontSize: '12px' }}>
//                                                                                                                         *{errors.name}
//                                                                                                                     </div>
//                                                                                                                 )}
//                                                                                                             </div>
//                                                                                                         </div>
//                                                                                                         <div className="col-md-6">
//                                                                                                             <div className="form-group mb-3">
//                                                                                                                 <label htmlFor="organisation_id" className="form-label" style={{ fontSize: '13px' }}>{isSalesOrderList ? 'Client Name' : 'Organisation Name'}:</label>
//                                                                                                                 <CreatableSelect
//                                                                                                                     isClearable
//                                                                                                                     options={[
//                                                                                                                         { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
//                                                                                                                         ...organisations.map(org => ({ value: org.id, label: org.name || org.company_name || org.first_name || "" }))
//                                                                                                                     ]}
//                                                                                                                     value={
//                                                                                                                         formData.organisation_id
//                                                                                                                             ? {
//                                                                                                                                 value: formData.organisation_id,
//                                                                                                                                 label: organisations.find(org => String(org.id) === String(formData.organisation_id))?.name ||
//                                                                                                                                     organisations.find(org => String(org.id) === String(formData.organisation_id))?.company_name ||
//                                                                                                                                     organisations.find(org => String(org.id) === String(formData.organisation_id))?.first_name || ""
//                                                                                                                             }
//                                                                                                                             : null
//                                                                                                                     }
//                                                                                                                     onChange={(selectedOption) => {
//                                                                                                                         if (!selectedOption) {
//                                                                                                                             setFormData(prev => ({ ...prev, organisation_id: '', contact_id: '' }));
//                                                                                                                             return;
//                                                                                                                         }
//                                                                                                                         if (selectedOption.value === "create_new") {
//                                                                                                                             setIsLeadModalHidden(true);
//                                                                                                                             setShowOrgModal(true);
//                                                                                                                             return;
//                                                                                                                         }
//                                                                                                                         setFormData(prev => ({ ...prev, organisation_id: selectedOption.value }));
//                                                                                                                     }}
//                                                                                                                     placeholder="Select"

//                                                                                                                 />

//                                                                                                             </div>
//                                                                                                         </div>
//                                                                                                         {!isSalesOrderList && (
//                                                                                                             <div className="col-md-6">

//                                                                                                                 <div className="form-group mb-3">
//                                                                                                                     <label htmlFor="customer_type" className="form-label" style={{ fontSize: '13px' }}>Customer Type:</label>
//                                                                                                                     <select
//                                                                                                                         style={{
//                                                                                                                             maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px', ...(isLimitedEdit
//                                                                                                                                 ? { backgroundColor: "#ffffff", cursor: "not-allowed" }
//                                                                                                                                 : {})
//                                                                                                                         }}
//                                                                                                                         name="customer_type"
//                                                                                                                         id="customer_type"
//                                                                                                                         className="form-control form-feild"
//                                                                                                                         value={formData.customer_type}
//                                                                                                                         onChange={handleChange}
//                                                                                                                         disabled={isLimitedEdit}
//                                                                                                                     >
//                                                                                                                         <option value="">Select </option>
//                                                                                                                         <option value="existing customer">Existing Customer </option>
//                                                                                                                         <option value="new customer">New Customer </option>

//                                                                                                                     </select>

//                                                                                                                 </div>
//                                                                                                             </div>
//                                                                                                         )}
//                                                                                                         {!isSalesOrderList && (
//                                                                                                             <div className="col-md-6">

//                                                                                                                 <div className="form-group mb-3">
//                                                                                                                     <label htmlFor="lead_source" className="form-label" style={{ fontSize: '13px' }}>Lead Source:</label>
//                                                                                                                     <select
//                                                                                                                         style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                         name="lead_source"
//                                                                                                                         id="lead_source"
//                                                                                                                         className="form-control form-feild"
//                                                                                                                         value={formData.lead_source}
//                                                                                                                         onChange={handleChange}
//                                                                                                                     >
//                                                                                                                         <option value="">Select </option>
//                                                                                                                         <option value="partner">Partner </option>
//                                                                                                                         <option value="consultant">Consultant </option>
//                                                                                                                         <option value="inside sales">Inside Sales </option>
//                                                                                                                         <option value="sales generated">Sales Generated </option>


//                                                                                                                     </select>

//                                                                                                                 </div>
//                                                                                                             </div>
//                                                                                                         )}

//                                                                                                         {formData.lead_source === 'partner' && (
//                                                                                                             <div className="col-md-6">

//                                                                                                                 <div className="form-group mb-3">
//                                                                                                                     <label htmlFor="partner_id" className="form-label" style={{ fontSize: '13px' }}>Partner Name:</label>
//                                                                                                                     <select
//                                                                                                                         style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                         name="partner_id"
//                                                                                                                         id="partner_id"
//                                                                                                                         value={formData.partner_id}
//                                                                                                                         onChange={handleChange}
//                                                                                                                         className='form-control form-feild'

//                                                                                                                     >

//                                                                                                                         <option value="">Select a Partner</option>
//                                                                                                                         {partnerOrganisations.map(org => (
//                                                                                                                             <option key={org.id} value={org.id}>
//                                                                                                                                 {org.name}
//                                                                                                                             </option>
//                                                                                                                         ))}
//                                                                                                                     </select>
//                                                                                                                 </div>
//                                                                                                             </div>
//                                                                                                         )}
//                                                                                                         {['consultant', 'inside sales', 'sales generated'].includes(formData.lead_source) && (
//                                                                                                             <div className="col-md-6">
//                                                                                                                 <div className="form-group mb-3">
//                                                                                                                     <label htmlFor="type_id" className="form-label" style={{ fontSize: '13px' }}>
//                                                                                                                         {formData.lead_source === 'consultant' ? 'Consultant Name' :
//                                                                                                                             formData.lead_source === 'inside sales' ? 'Select Inside Sales' :
//                                                                                                                                 ' Select Sales Generated'}
//                                                                                                                     </label>
//                                                                                                                     <select
//                                                                                                                         style={{
//                                                                                                                             maxWidth: '280px',
//                                                                                                                             border: '0.5px solid rgb(232, 233, 237)',
//                                                                                                                             borderRadius: '14px',
//                                                                                                                         }}
//                                                                                                                         name="type_id"
//                                                                                                                         id="type_id"
//                                                                                                                         value={formData.type_id}
//                                                                                                                         onChange={handleChange}
//                                                                                                                         className="form-control form-feild"
//                                                                                                                     >
//                                                                                                                         <option value="">Select</option>
//                                                                                                                         {filteredContacts.map(contact => (
//                                                                                                                             <option key={contact.id} value={contact.id}>
//                                                                                                                                 {contact.name}
//                                                                                                                             </option>
//                                                                                                                         ))}
//                                                                                                                     </select>
//                                                                                                                 </div>
//                                                                                                             </div>
//                                                                                                         )}

//                                                                                                         <div className="col-md-6">

//                                                                                                             <div className="form-group mb-3">
//                                                                                                                 <label htmlFor="stage" className="form-label" style={{ fontSize: '13px' }}>Stage:</label>
//                                                                                                                 <select
//                                                                                                                     style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                     name="stage"
//                                                                                                                     id="stage"
//                                                                                                                     className={`form-control form-feild ${errors?.stage ? 'is-invalid' : ''}`}
//                                                                                                                     value={formData.stage}
//                                                                                                                     onChange={handleChange}
//                                                                                                                 >
//                                                                                                                     <option value="">Select </option>
//                                                                                                                     <option value="suspect">Suspect </option>
//                                                                                                                     <option value="prospect">Prospect </option>
//                                                                                                                     <option value="approach">Approach </option>
//                                                                                                                     <option value="negotiation">Negotiation </option>
//                                                                                                                     <option value="closed won">Closed Won </option>
//                                                                                                                     <option value="closed lost">Closed Lost </option>
//                                                                                                                     <option value="closed dead">Closed Dead </option>
//                                                                                                                     <option value="order">Order </option>
//                                                                                                                 </select>
//                                                                                                                 {errors.stage && (
//                                                                                                                     <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
//                                                                                                                         *{errors.stage}
//                                                                                                                     </div>
//                                                                                                                 )}

//                                                                                                             </div>
//                                                                                                         </div>



//                                                                                                         {!isSalesOrderList && (
//                                                                                                             <div className="col-md-6">
//                                                                                                                 <div className="form-group mb-3">
//                                                                                                                     <label htmlFor="probability" className="form-label" style={{ fontSize: '13px' }}>Probability(%):</label>
//                                                                                                                     <input
//                                                                                                                         style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                         name="probability"
//                                                                                                                         id="probability"
//                                                                                                                         className="form-control form-feild"
//                                                                                                                         value={formData.probability !== '' ? formData.probability : '0'}
//                                                                                                                         onChange={handleChange}
//                                                                                                                         readOnly
//                                                                                                                     />
//                                                                                                                 </div>
//                                                                                                             </div>
//                                                                                                         )}
//                                                                                                         <div className="col-md-6">

//                                                                                                             <div className="form-group mb-3">
//                                                                                                                 <label htmlFor="value" className="form-label" style={{ fontSize: '13px' }}>Value</label>
//                                                                                                                 <input
//                                                                                                                     style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                     name="value"
//                                                                                                                     id="value"
//                                                                                                                     className='form-control form-feild'
//                                                                                                                     value={formData.value}
//                                                                                                                     onChange={handleChange}
//                                                                                                                 />
//                                                                                                             </div>
//                                                                                                         </div>



//                                                                                                         {!isSalesOrderList && (
//                                                 <>
//                                                                                                                 <div className="col-md-6">


//                                                                                                                     <div className="form-group mb-3">
//                                                                                                                         <label htmlFor="expected_revenue" className="form-label" style={{ fontSize: '13px' }}>Expected Revenue:</label>
//                                                                                                                         <input
//                                                                                                                             style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                             name="expected_revenue"
//                                                                                                                             id="expected_revenue"
//                                                                                                                             className="form-control form-feild"
//                                                                                                                             value={formData.expected_revenue}
//                                                                                                                             onChange={handleChange}
//                                                                                                                             readOnly

//                                                                                                                         />
//                                                                                                                     </div>
//                                                                                                                 </div>
//                                                                                                                 {/* <div className="col-md-6">

//                                             <div className="form-group mb-3">
//                                                 <label htmlFor="products" className="form-label" style={{ fontSize: '13px' }}>Product:</label>

//                                                 <CreatableSelect
//                                                     isMulti
//                                                     isClearable
//                                                     options={[
//                                                         { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
//                                                         ...allProducts.map(product => ({
//                                                             value: product.id,
//                                                             label: product.product_name
//                                                         }))
//                                                     ]}
//                                                     value={formData.products.map(p => ({
//                                                         value: p.product_id,
//                                                         item_name: p.item_name
//                                                     }))}
//                                                     onChange={(selectedOptions) => {
//                                                         if (!selectedOptions || selectedOptions.length === 0) {
//                                                             setFormData(prev => ({
//                                                                 ...prev,
//                                                                 products: []
//                                                             }));
//                                                             return;
//                                                         }

//                                                         const containsNewProduct = selectedOptions.some(option => option.value === "create_new");
//                                                         console.log("Contains 'Add New' Option:", containsNewProduct);
//                                                         if (containsNewProduct) {
//                                                             console.log("Opening Product Form Modal");
//                                                             setIsLeadModalHidden(true);
//                                                             setShowProductModal(true);
//                                                         } else {
//                                                             setFormData(prev => ({
//                                                                 ...prev,
//                                                                 products: selectedOptions.map(option => ({
//                                                                     product_id: option.value,
//                                                                     item_name: option.label,
//                                                                     item_description: allProducts.find(p => p.id === option.value)?.description || '',
//                                                                     quantity: 1,
//                                                                     price: allProducts.find(p => p.id === option.value)?.price || ''
//                                                                 }))
//                                                             }));
//                                                         }
//                                                     }}
//                                                     className="basic-multi-select"
//                                                     classNamePrefix="select"
//                                                     menuPortalTarget={document.body}
//                                                     styles={{
//                                                         control: (provided, state) => ({
//                                                             ...provided,
//                                                             fontSize: '14px',
//                                                             borderRadius: '14px',
//                                                             minHeight: '39px',
//                                                             border: '0.5px solid rgb(232, 233, 237)',
//                                                             flexWrap: 'wrap', // Allows multiple selections to wrap properly
//                                                             overflow: 'auto', // Enables scrolling if needed
//                                                             maxHeight: state.hasValue ? 'auto' : '39px', // Adjust height when values are selected
//                                                         }),
//                                                         valueContainer: (provided) => ({
//                                                             ...provided,
//                                                             flexWrap: 'wrap', // Ensures selected items wrap within the field
//                                                             maxHeight: '100px', // Set a max height to avoid excessive growth
//                                                             overflowY: 'auto', // Enables scrolling when necessary
//                                                         }),
//                                                         menuPortal: (base) => ({ ...base, zIndex: 9999 })
//                                                     }}
//                                                 />


//                                             </div>


//                                         </div> */}



//                                                                                                                 <div className="col-md-6">
//                                                                                                                     <div className="form-group mb-3">
//                                                                                                                         <label htmlFor="brand_id" className="form-label" style={{ fontSize: '13px' }}>
//                                                                                                                             Brand:
//                                                                                                                         </label>
//                                                                                                                         <Select
//                                                                                                                             isMulti
//                                                                                                                             name="brand_id"
//                                                                                                                             // In your Select component:
//                                                                                                                             options={brands?.map((brand) => ({
//                                                                                                                                 value: brand.id,
//                                                                                                                                 label: brand.name,
//                                                                                                                             })) || []}

//                                                                                                                             // And in the value prop:
//                                                                                                                             // In your Select component's value prop
//                                                                                                                             value={((brands || []))?.filter((brand) =>
//                                                                                                                                 (formData.brand_id || []).some(bid => String(bid) === String(brand.id))
//                                                                                                                             ).map((brand) => ({
//                                                                                                                                 value: brand.id,
//                                                                                                                                 label: brand.name,
//                                                                                                                             }))}
//                                                                                                                             onChange={(selectedOptions) => {
//                                                                                                                                 setFormData({
//                                                                                                                                     ...formData,
//                                                                                                                                     brand_id: selectedOptions.map((option) => option.value),
//                                                                                                                                 });
//                                                                                                                             }}
//                                                                                                                             className="basic-multi-select"
//                                                                                                                             classNamePrefix="select"
//                                                                                                                             styles={{
//                                                                                                                                 control: (provided) => ({
//                                                                                                                                     ...provided,
//                                                                                                                                     fontSize: '14px',
//                                                                                                                                     maxWidth: '280px',
//                                                                                                                                     borderRadius: '14px',
//                                                                                                                                     height: '39px',
//                                                                                                                                     border: '0.5px solid rgb(232, 233, 237)',
//                                                                                                                                 }),
//                                                                                                                             }}
//                                                                                                                         />
//                                                                                                                     </div>
//                                                                                                                 </div>



//                                                                                                                 <div className="col-md-6">
//                                                                                                                     <div className="form-group mb-3">
//                                                                                                                         <label htmlFor="closed_date" className="form-label d-block" style={{ fontSize: '13px' }}>Expected Closed Date:</label>

//                                                                                                                         <div className="datepicker-wrapper w-280">
//                                                                                                                             <DatePicker
//                                                                                                                                 format="DD-MM-YYYY"
//                                                                                                                                 value={formData.closed_date ? dayjs(formData.closed_date) : null}
//                                                                                                                                 onChange={(date) => handleDateChange('closed_date', date)}
//                                                                                                                                 slotProps={{
//                                                                                                                                     textField: {
//                                                                                                                                         fullWidth: true,
//                                                                                                                                         size: "small",
//                                                                                                                                         sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                                                     }
//                                                                                                                                 }}
//                                                                                                                             />
//                                                                                                                         </div>
//                                                                                                                         <div className="col-md-6">


//                                                                                                                             <div className="form-group mb-3">
//                                                                                                                                 <label htmlFor="next_steps" className="form-label" style={{ fontSize: '13px' }}>Next Step:</label>
//                                                                                                                                 <input
//                                                                                                                                     style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                                     name="next_steps"
//                                                                                                                                     id="next_steps"
//                                                                                                                                     type='text'
//                                                                                                                                     className="form-control form-feild"
//                                                                                                                                     value={formData.next_steps}
//                                                                                                                                     onChange={handleChange}

//                                                                                                                                 />
//                                                                                                                             </div>

//                                                                                                                         </div>


//                                                                                                                         <div className="col-md-6">


//                                                                                                                             <div className="form-group mb-3">
//                                                                                                                                 <label htmlFor="remarks" className="form-label" style={{ fontSize: '13px' }}>Remarks:</label>
//                                                                                                                                 <textarea
//                                                                                                                                     style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
//                                                                                                                                     name="remarks"
//                                                                                                                                     id="remarks"
//                                                                                                                                     className="form-control form-feild"
//                                                                                                                                     value={formData.remarks}
//                                                                                                                                     onChange={handleChange}


//                                                                                                                                 />
//                                                                                                                             </div>
//                                                                                                                         </div>
//                                                                                                                     </>
//                                             )}
//                                                                                                                     {(isOrdersPage && dealData && dealData.id) && (
//                                                                                                                         <div className="col-md-6">
//                                                                                                                             <div className="form-group mb-3">
//                                                                                                                                 <label htmlFor="revenue_type" className="form-label" style={{ fontSize: "13px" }}>WHT(%)</label>
//                                                                                                                                 <input
//                                                                                                                                     type="text"
//                                                                                                                                     name="WHT"
//                                                                                                                                     className="form-control form-feild"
//                                                                                                                                     value={formData.WHT}
//                                                                                                                                     onChange={handleChange}
//                                                                                                                                     style={{
//                                                                                                                                         maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px',
//                                                                                                                                     }}
//                                                                                                                                 />
//                                                                                                                             </div>
//                                                                                                                         </div>
//                                                                                                                     )}

//                                                                                                                     {(isOrdersPage && dealData && dealData.id && revenueType === 'subscription') && (
//                                                 <>
//                                                                                                                             <div className="col-md-6">
//                                                                                                                                 <div className="form-group mb-3">
//                                                                                                                                     <label htmlFor="payment_term" className="form-label" style={{ fontSize: "13px" }}>Payment Term</label>
//                                                                                                                                     <select
//                                                                                                                                         name="payment_term"
//                                                                                                                                         id="payment_term"
//                                                                                                                                         className="form-control"
//                                                                                                                                         value={formData.payment_term}
//                                                                                                                                         onChange={handleChange}
//                                                                                                                                         style={{
//                                                                                                                                             fontSize: '13px',
//                                                                                                                                             maxWidth: '280px',
//                                                                                                                                             borderRadius: '14px',
//                                                                                                                                             height: '35px',
//                                                                                                                                             border: '0.5px solid rgb(232, 233, 237)'
//                                                                                                                                         }}
//                                                                                                                                     >
//                                                                                                                                         <option value="">Select</option>
//                                                                                                                                         <option value="yearly">Yearly</option>
//                                                                                                                                         <option value="half-yearly">Half Yearly</option>
//                                                                                                                                         <option value="quarterly">Quarterly</option>
//                                                                                                                                         <option value="custom">Custom</option>
//                                                                                                                                     </select>
//                                                                                                                                 </div>
//                                                                                                                             </div>
//                                                                                                                             <div className="col-md-6">
//                                                                                                                                 <div className="form-group mb-3">
//                                                                                                                                     <label htmlFor="subscription_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>


//                                                                                                                                     <div className="datepicker-wrapper w-280">
//                                                                                                                                         <DatePicker
//                                                                                                                                             format="DD-MM-YYYY"
//                                                                                                                                             value={formData.subscription_start_date ? dayjs(formData.subscription_start_date) : null}
//                                                                                                                                             onChange={(date) => handleDateChange('subscription_start_date', date)}
//                                                                                                                                             slotProps={{
//                                                                                                                                                 textField: {
//                                                                                                                                                     fullWidth: true,
//                                                                                                                                                     size: "small",
//                                                                                                                                                     sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                                                                 }
//                                                                                                                                             }}
//                                                                                                                                         />
//                                                                                                                                     </div>

//                                                                                                                                     <div className="col-md-6">
//                                                                                                                                         <div className="form-group mb-3">
//                                                                                                                                             <label htmlFor="vendor_subscription_end_dates" className="form-label d-block" style={{ fontSize: "13px" }}>End Date</label>

//                                                                                                                                             <div className="datepicker-wrapper w-280">
//                                                                                                                                                 <DatePicker
//                                                                                                                                                     format="DD-MM-YYYY"
//                                                                                                                                                     value={formData.vendor_subscription_end_dates ? dayjs(formData.vendor_subscription_end_dates) : null}
//                                                                                                                                                     onChange={(date) => handleDateChange('vendor_subscription_end_dates', date)}
//                                                                                                                                                     slotProps={{
//                                                                                                                                                         textField: {
//                                                                                                                                                             fullWidth: true,
//                                                                                                                                                             size: "small",
//                                                                                                                                                             sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                                                                         }
//                                                                                                                                                     }}
//                                                                                                                                                 />
//                                                                                                                                             </div>
//                                                                                                                                             <div className="col-md-6">
//                                                                                                                                                 <div className="form-group mb-3">
//                                                                                                                                                     <label htmlFor="subscription_due_date" className="form-label d-block" style={{ fontSize: "13px" }}>Due Date</label>


//                                                                                                                                                     <div className="datepicker-wrapper w-280">
//                                                                                                                                                         <DatePicker
//                                                                                                                                                             format="DD-MM-YYYY"
//                                                                                                                                                             value={formData.subscription_due_date ? dayjs(formData.subscription_due_date) : null}
//                                                                                                                                                             onChange={(date) => handleDateChange('subscription_due_date', date)}
//                                                                                                                                                             slotProps={{
//                                                                                                                                                                 textField: {
//                                                                                                                                                                     fullWidth: true,
//                                                                                                                                                                     size: "small",
//                                                                                                                                                                     sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                                                                                 }
//                                                                                                                                                             }}
//                                                                                                                                                         />
//                                                                                                                                                     </div>
//                                                                                                                                                 </>
//                                             )}
//                                                                                                                                                 {revenueType === 'deployment' && isOrdersPage && dealData && dealData.id && (
//                                                                                                                                                     <>
//                                                                                                                                                         <div className="col-md-6">
//                                                                                                                                                             <div className="form-group mb-3">
//                                                                                                                                                                 <label htmlFor="deployment_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>

//                                                                                                                                                                 <div className="datepicker-wrapper w-280">
//                                                                                                                                                                     <DatePicker
//                                                                                                                                                                         format="DD-MM-YYYY"
//                                                                                                                                                                         value={formData.deployment_start_date ? dayjs(formData.deployment_start_date) : null}
//                                                                                                                                                                         onChange={(date) => handleDateChange('deployment_start_date', date)}
//                                                                                                                                                                         slotProps={{
//                                                                                                                                                                             textField: {
//                                                                                                                                                                                 fullWidth: true,
//                                                                                                                                                                                 size: "small",
//                                                                                                                                                                                 sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                                                                                             }
//                                                                                                                                                                         }}
//                                                                                                                                                                     />
//                                                                                                                                                                 </div>

//                                                                                                                                                                 <div className="col-md-6">
//                                                                                                                                                                     <div className="form-group mb-3">
//                                                                                                                                                                         <label htmlFor="deployment_end_date" className="form-label d-block" style={{ fontSize: "13px" }}>Deployment End</label>

//                                                                                                                                                                         <div className="datepicker-wrapper w-280">
//                                                                                                                                                                             <DatePicker
//                                                                                                                                                                                 format="DD-MM-YYYY"
//                                                                                                                                                                                 value={formData.deployment_end_date ? dayjs(formData.deployment_end_date) : null}
//                                                                                                                                                                                 onChange={(date) => handleDateChange('deployment_end_date', date)}
//                                                                                                                                                                                 slotProps={{
//                                                                                                                                                                                     textField: {
//                                                                                                                                                                                         fullWidth: true,
//                                                                                                                                                                                         size: "small",
//                                                                                                                                                                                         sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
//                                                                                                                                                                                     }
//                                                                                                                                                                                 }}
//                                                                                                                                                                             />
//                                                                                                                                                                         </div>
//                                                                                                                                                                     </>
//                                             )}
//                                                                                                                                                                 </>

//                                     )}
//                                                                                                                                                             </div>
//                                                                                                                                                         </LocalizationProvider>
//                                                                                                                                                     </form>
//                                                                                                                                             </Offcanvas.Body>

//                                                                                                                                             <div className="p-3 d-flex justify-content-end border-top">
//                                                                                                                                                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                                                                                                                                                     Close
//                                                                                                                                                 </button>
//                                                                                                                                                 <button type="button" className="btn btn-primary" onClick={handleSubmit}>
//                                                                                                                                                     Save
//                                                                                                                                                 </button>
//                                                                                                                                             </div>
//                                                                                                                                         </Offcanvas >
//                                                                                                                                         )
//             }

//                                                                                                                                         {
//                                                                                                                                             showOrgModal && (
//                                                                                                                                                 <OrganisationModal
//                                                                                                                                                     showModal={showOrgModal}
//                                                                                                                                                     handleClose={handleOrgModalClose}
//                                                                                                                                                     fetchIndustries={fetchIndustries}
//                                                                                                                                                     industries={industries}
//                                                                                                                                                     addOrg={addOrganisation}

//                                                                                                                                                 />
//                                                                                                                                             )
//                                                                                                                                         }
//                                                                                                                                         {
//                                                                                                                                             showProductModal && (
//                                                                                                                                                 <ProductForm
//                                                                                                                                                     showModal={showProductModal}
//                                                                                                                                                     handleClose={handleProductModalClose}
//                                                                                                                                                     categories={categories}
//                                                                                                                                                     fetchCategories={fetchCategories}
//                                                                                                                                                     addProduct={addProducts}
//                                                                                                                                                     fetchBrands={fetchBrands}
//                                                                                                                                                     brands={brands}
//                                                                                                                                                     vendors={vendors}
//                                                                                                                                                     fetchVendors={fetchVendors}

//                                                                                                                                                 />
//                                                                                                                                             )
//                                                                                                                                         }
//                                                                                                                                     </div >
//                                                                                                                                     );
// };

//                                                                                                                                     export default DealModal;













import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import Select from 'react-select';
import { Offcanvas } from 'react-bootstrap';
import OrganisationModal from '../organisation/OrganisationModal';
import CreatableSelect from 'react-select/creatable';
import { FaPlus } from "react-icons/fa";
import ProductForm from '../../product/ProductForm';
import { useLocation } from 'react-router-dom';
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DealModal = ({
    showModal,
    handleClose,
    dealId,
    dealData,
    addDeal,
    editDeal,
    deals,
    organisations,
    fetchOrganisation,
    setOrganisation,
    revenueType,
    isSalesOrderList

}) => {
    const [formData, setFormData] = useState({
        organisation_id: '',
        stage: '',
        name: '',
        value: '',
        expected_revenue: '',
        closed_date: '',
        probability: '',
        lead_source: '',
        next_steps: '',
        customer_type: '',
        remarks: '',
        partner_name: '',
        partner_id: '',

        transaction_type: '',
        margin_percentage: '',
        products: [],
        type_id: '',
        subscription_start_date: '',
        vendor_subscription_end_dates: '',
        subscription_due_date: '',
        deployment_start_date: '',
        deployment_end_date: '',
        brand_id: [],
        assigned_to: '',
        WHT: '',
        payment_term: '',
    });
    const [activeTab, setActiveTab] = useState(0);
    const [allProducts, setAllProducts] = useState([]);
    const [partners, setPartner] = useState([]);
    const [showOrgModal, setShowOrgModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);
    const [isLeadModalHidden, setIsLeadModalHidden] = useState(false);
    const [industries, setIndustries] = useState([]);
    const [errors, setErrors] = useState({});
    const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
    const [brands, setBrands] = useState([]);
    const [vendors, setVendors] = useState({ allVendors: [] });
    const [contacts, setContacts] = useState([]);
    const [users, setUsers] = useState([]);
    const [showBrandModal, setShowBrandModal] = useState(false);
    const location = useLocation();

    // Check if we're on the /orders page
    const isOrdersPage =
        location.pathname === '/orders' ||
        location.pathname.startsWith(`/deal/details/${dealId}`) || isSalesOrderList;

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            let allIndustries = [];
            let currentPage = 1;
            let lastPage = 1;


            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });

            allIndustries = [...allIndustries, ...response.data.industry]


            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };
    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            // const filteredContacts = response.data.Data.filter(
            //     contact => contact.type !== "instance" && contact.type !== "tenant"
            // );

            setContacts(response.data.Data);

        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const fetchProducts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/products`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });


            if (Array.isArray(response.data.Data)) {
                setAllProducts(response.data.Data);
            } else {
                console.error("Invalid response format", response.data);
            }

        } catch (error) {
            console.error('Error fetching instances:', error);
        }
    };
    const fetchCategories = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allCategories = [];

            const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allCategories = [...allCategories, ...response.data.category];

            const allCategoriesList = allCategories.filter(cat => !cat.parent_id);

            // All subcategories (categories with parent_id)
            const allSubcategories = allCategories.filter(cat => cat.parent_id);

            setCategories({ allCategoriesList, allSubcategories });
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchUsers = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/users`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const userOptions = response.data.users.map(user => ({
                value: user.id,
                label: `${user.name} (${user.roles?.map(r => r.name).join(', ') || 'No Role'})`
            }));

            setUsers(userOptions);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchBrands = async () => {
        console.log("⚙️ Fetching brands...");
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/brands`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });
            console.log("Brand API response:", response.data);

            // const data = response.data?.brand;
            // console.log("Brand API response:", data);
            let brandsData = response.data?.brand || response.data?.data || response.data;

            // Ensure it's always an array
            if (!Array.isArray(brandsData)) {
                // If it's an object with a results/data property, use that
                brandsData = brandsData?.results || brandsData?.data || [];
            }



            console.log("Processed brands data:", brandsData);
            setBrands(brandsData);
        } catch (error) {
            console.error('Error fetching brands:', error);
            setBrands([]); // Set empty array on error
        }
    };
    const fetchVendors = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let allVendors = [];

            const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });

            // const { data, current_page, last_page } = response.data.Data;
            allVendors = [...allVendors, ...response.data.Data];

            setVendors({ allVendors });

        } catch (error) {
            console.error(`Error fetching vendors:`, error);
        }
    };

    useEffect(() => {
        if (showModal) {

            // fetchProducts();
            fetchBrands();
        }
    }, [showModal]);
    const [filteredContacts, setFilteredContacts] = useState([]);

    const handleOrgModalClose = (newOrg) => {
        setShowOrgModal(false);

        if (newOrg) {
            setAllProducts((prev) => [...prev, newOrg]); // Add new org to the list

            // Ensure formData is updated with the new org ID
            setFormData((prev) => ({
                ...prev,
                organisation_id: newOrg.id,
                contact_id: ''
            }));

        }
        setIsLeadModalHidden(false);
    };
    const handleProductModalClose = (newProduct) => {
        setShowProductModal(false);

        if (newProduct) {
            setAllProducts((prev) => [...prev, newProduct]);
            setFormData((prev) => ({
                ...prev,
                products: [...prev.products, { product_id: newProduct.id, item_name: newProduct.product_name, quantity: 1, price: newProduct?.product?.selling_price }],
            }));
        }
        setIsLeadModalHidden(false);
    };
    const handleBrandModalClose = (newProduct) => {
        setShowProductModal(false);

        if (newProduct) {
            setAllProducts((prev) => [...prev, newProduct]);
            setFormData((prev) => ({
                ...prev,
                products: [...prev.products, { product_id: newProduct.id, item_name: newProduct.product_name, quantity: 1, price: newProduct?.product?.selling_price }],
            }));
        }
        setIsLeadModalHidden(false);
    };
    const addProducts = async (newProduct) => {
        try {
            const formData = new FormData();
            // Append regular fields
            Object.keys(newProduct).forEach((key) => {
                formData.append(key, newProduct[key]);
            });

            if (newProduct.product_image) {
                formData.append('product_image', newProduct.avatar);
            }
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/products`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,


                },
            });
            const createdProduct = response.data.Data;

            if (createdProduct) {
                setAllProducts((prevProducts) => [...prevProducts, createdProduct]);
                setFormData((prev) => ({
                    ...prev,
                    products: [...prev.products, { product_id: createdProduct.id, item_name: createdProduct.product_name, item_description: createdProduct.description, quantity: 1, price: createdProduct.product?.selling_price }],
                }));
                setShowProductModal(false);
            } else {
                console.error('Creation failed, no data returned.');
            }

            setShowProductModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };
    const addOrganisation = async (newOrganisation) => {
        try {
            const formData = new FormData();
            // Append regular fields
            Object.keys(newOrganisation).forEach((key) => {
                formData.append(key, newOrganisation[key]);
            });


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/organisation`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const createdOrganisation = response.data.data;

            if (createdOrganisation) {
                setOrganisation((prevOrganisation) => [...prevOrganisation, createdOrganisation]);
                setFormData(prev => ({ ...prev, organisation_id: createdOrganisation.id }));
                // return createdOrganisation; 
            } else {
                console.error('Creation failed, no data returned.');
            }

            setShowOrgModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };

    useEffect(() => {
        if (showModal && organisations?.length === 0) {
            fetchOrganisation();
        }
        if (showModal && contacts?.length === 0) {
            fetchContacts();
        }
        if (showModal && users?.length === 0) {
            fetchUsers();
        }
        if (showModal && !dealData) {
            // Reset formData for new orgs creation
            setFormData({
                organisation_id: '',
                stage: '',
                name: '',
                value: '',
                closed_date: '',
                probability: '',
                expected_revenue: '',
                lead_source: '',
                next_steps: '',
                customer_type: '',
                remarks: '',
                partner_name: '',
                partner_id: '',

                transaction_type: '',
                margin_percentage: '',
                products: [],
                type_id: '',
                subscription_start_date: '',
                vendor_subscription_end_dates: '',
                subscription_due_date: '',
                deployment_start_date: '',
                deployment_end_date: '',
                brand_id: [],
                assigned_to: '',
            });
        } else if (dealData) {
            setFormData({
                organisation_id: dealData.organisation_id || dealData.client_id || '',
                stage: dealData.stage || '',
                value: dealData.value || '',
                closed_date: dealData.closed_date || '',

                probability: dealData.probability !== undefined ? dealData.probability : getProbability(dealData.stage),
                name: dealData.name || '',
                expected_revenue: dealData.expected_revenue || '',
                lead_source: dealData.lead_source || '',
                next_steps: dealData.next_steps || '',
                customer_type: dealData.customer_type || '',
                remarks: dealData.remarks || '',
                partner_name: dealData.partner_name || '',
                partner_id: dealData.partner_id || '',

                transaction_type: dealData.transaction_type || '',
                margin_percentage: dealData.margin_percentage || '',
                type_id: dealData.type_id || '',
                subscription_start_date: dealData?.quotation?.project?.subscription_start_date || '',
                vendor_subscription_end_dates: dealData?.quotation?.project?.vendor_subscription_end_dates || '',
                subscription_due_date: dealData?.quotation?.project?.subscription_due_date || '',
                // Add payment_term from dealData if it exists
                payment_term: dealData?.quotation?.project?.payment_term || '',
                deployment_start_date: dealData?.quotation?.project?.deployment_start_date || '',
                deployment_end_date: dealData?.quotation?.project?.deployment_end_date || '',
                brand_id: dealData.brand_id
                    ? (Array.isArray(dealData.brand_id)
                        ? dealData.brand_id
                        : JSON.parse(dealData.brand_id || '[]')).map(id => parseInt(id))
                    : [],
                assigned_to: dealData.assigned_to || '',
                products: Array.isArray(dealData.product_item_details) // Match the backend key exactly
                    ? dealData.product_item_details.map(p => ({
                        product_id: p.product_id, // Assuming the product ID is under 'id'
                        item_name: p.item_name || p.product_name,
                        quantity: p.quantity || 1,
                        price: p.price || 0
                    }))
                    : [],
                WHT: dealData.WHT || '',

            });

        }
    }, [dealData, showModal, contacts]);

    const handleProductChange = (selectedOptions) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            products: selectedOptions.map(option => ({
                product_id: option.value,  // Ensure correct ID
                item_name: option.label,
                item_description: allProducts.find(p => p.id === option.value)?.description || '',
                quantity: 1,
                price: 0
            }))
        }));
    };


    const productOptions = allProducts.map(product => ({
        value: product.id,
        label: product.product_name
    }));



    const removeProduct = (productId) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            products: prevFormData.products.filter(product => product.product_id !== productId)
        }));
    };


    const getProbability = (stage) => {
        const probabilities = {
            suspect: 10,
            prospect: 25,
            approach: 50,
            negotiation: 75,
            "closed won": 90,
            "closed lost": 0,
            "closed dead": 0,
            order: 100
        };
        return probabilities[stage] || '';
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFormData = { ...formData, [name]: value };

        if (name === "stage") {
            // Update probability when stage changes
            const newProbability = getProbability(value);
            newFormData.probability = newProbability;
        }

        if (name === "value" || name === "stage") {
            // Recalculate expected revenue when value or stage changes
            const numericValue = parseFloat(newFormData.value) || 0;
            const numericProbability = parseFloat(newFormData.probability) || 0;
            newFormData.expected_revenue = (numericValue * numericProbability) / 100;
        }

        if (name === "lead_source") {
            if (value?.trim()?.toLowerCase() !== 'partner' && newFormData.transaction_type === 'partner') {
                // If it was partner but user changed source away, default to direct
                newFormData.transaction_type = 'direct';
                newFormData.partner_id = '';
            }
        }

        setFormData(newFormData);
        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };

    const handleDateChange = (name, date) => {
        setFormData(prev => ({
            ...prev,
            [name]: date ? dayjs(date).format('YYYY-MM-DD') : ''
        }));
        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };




    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (formData.stage === 'negotiation' && (!dealData || !dealData.quotation_id)) {
            newErrors.stage = 'Cannot select Negotiation stage without a quotation. Please create a quotation first.';
        }

        return newErrors;
    };
    const [loading, setLoading] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        const updatedFormData = {
            ...formData,
            ...(isSalesOrderList ? { client_id: formData.organisation_id } : {}),
            products: formData.products.map(p => ({
                product_id: p.product_id,
                quantity: p.quantity,
                price: p.price,
                item_name: p.item_name,
                item_description: p.item_description
            }))
        };
        let errors;
        if (dealData && dealData.id) {
            errors = await editDeal(dealData.id, updatedFormData);
        } else {
            errors = await addDeal(updatedFormData);
        }

        if (errors && Object.keys(errors).length > 0) {
            setErrors(errors); // Display validation errors
        } else {
            setErrors({}); // Clear errors on success
            handleClose(); // Close modal on success
        }
    };
    const partnerOrganisations = organisations?.filter(org => org.org_type === 'partner');


    useEffect(() => {
        const leadSource = formData.lead_source?.toLowerCase();

        if (leadSource === 'partner' && formData.partner_id) {
            const partnerOrganisation = organisations.find(
                (org) => String(org.id) === String(formData.partner_id)
            );

            if (partnerOrganisation?.org_type?.toLowerCase() === 'partner') {
                setFilteredContacts(partnerOrganisation.contacts || []);
            }
        } else if (['consultant', 'inside sales', 'sales generated'].includes(leadSource)) {
            const typeNameMap = {
                consultant: 'consultant',
                'inside sales': 'inside sales',
                'sales generated': 'sales generated'
            };

            setFilteredContacts(
                (contacts || []).filter(contact =>  // ✅ Prevents undefined error
                    contact.contact_type?.toLowerCase() ===
                    (leadSource === 'consultant' ? 'external' : 'internal') &&
                    contact.type_id &&
                    (contact.type?.name?.toLowerCase() === typeNameMap[leadSource])
                )
            );

        } else {
            const selectedOrg = organisations.find(
                (org) => String(org.id) === String(formData.organisation_id)
            );
            setFilteredContacts(selectedOrg?.contacts || []);
        }
    }, [organisations, formData.organisation_id, formData.partner_id, contacts, formData.lead_source]);
    const isEditMode = Boolean(dealId); // true if editing
    const isLimitedEdit =
        isEditMode && (revenueType === "subscription" || revenueType === "deployment");
    const commonFieldStyles = {
        border: '0.5px solid rgb(232, 233, 237)',
        borderRadius: '14px',
        height: '39px',
        fontSize: '13px',
    };

    return (

        <div>
            <div>
                {showModal && (
                    <div
                        className="custom-backdrop"
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            // backgroundColor: 'rgba(0, 0, 0, 0.25)', // light dim (Bootstrap style)
                            zIndex: 1059, // between parent & child offcanvas
                        }}
                    />
                )}
            </div>



            {showModal && !isLeadModalHidden && (

                <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '650px' }} backdrop="static">
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>
                            {dealId ? 'Edit' : 'Add'}
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <hr style={{ margin: 0 }} /><br />


                    <Offcanvas.Body>
                        <form onSubmit={handleSubmit}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="row">
                                    {isSalesOrderList ? (
                                        <div className="col-12 px-3">
                                            {/* Basic Details Section */}
                                            <div className="mb-4">
                                                <h6 className="fw-semibold text-primary mb-3" style={{ borderBottom: '1px solid #eee', paddingBottom: '8px' }}>Basic Details</h6>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="name" className="form-label" style={{ fontSize: '13px' }}>Project Name</label>
                                                            <input
                                                                name="name" id="name" type="text" value={formData.name} onChange={handleChange}
                                                                className={`form-control form-feild ${errors?.name ? 'is-invalid' : ''}`}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="organisation_id" className="form-label" style={{ fontSize: '13px' }}>Client Name</label>
                                                            <CreatableSelect
                                                                isClearable
                                                                options={organisations.map(org => ({
                                                                    value: org.id,
                                                                    label: org.name || org.company_name || `${org.first_name || ""} ${org.last_name || ""}`.trim() || `Client ${org.id}`
                                                                }))}
                                                                value={
                                                                    formData.organisation_id
                                                                        ? {
                                                                            value: formData.organisation_id,
                                                                            label: (organisations.find(org => String(org.id) === String(formData.organisation_id))?.name ||
                                                                                organisations.find(org => String(org.id) === String(formData.organisation_id))?.company_name ||
                                                                                organisations.find(org => String(org.id) === String(formData.organisation_id))?.first_name ||
                                                                                dealData?.client?.name || dealData?.quotation?.project?.client?.name || "")
                                                                        }
                                                                        : null
                                                                }
                                                                onChange={(newValue) => {
                                                                    setFormData(prev => ({ ...prev, organisation_id: newValue ? newValue.value : "" }));
                                                                }}
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        fontSize: '13px',
                                                                        borderRadius: '14px',
                                                                        height: '39px',
                                                                        minHeight: '39px',
                                                                        border: '0.5px solid rgb(232, 233, 237)'
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        fontSize: '13px'
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="stage" className="form-label" style={{ fontSize: '13px' }}>Stage</label>
                                                            <select
                                                                style={{ border: '0.5px solid rgb(232, 233, 237)' }}
                                                                name="stage" id="stage" className={`form-control form-feild ${errors?.stage ? 'is-invalid' : ''}`}
                                                                value={formData.stage} onChange={handleChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="approach">Approach</option>
                                                                <option value="negotiation">Negotiation</option>
                                                                <option value="closed won">Closed Won</option>
                                                                <option value="order">Order</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="value" className="form-label" style={{ fontSize: '13px' }}>Value</label>
                                                            <input
                                                                name="value" id="value" className='form-control form-feild' value={formData.value} onChange={handleChange}
                                                                style={{ border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="WHT" className="form-label" style={{ fontSize: "13px" }}>WHT(%)</label>
                                                            <input
                                                                type="text" name="WHT" className="form-control form-feild" value={formData.WHT} onChange={handleChange}
                                                                style={{ border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            />
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>

                                            {/* Subscription Details Section */}
                                            <div className="mb-4">
                                                <h6 className="fw-semibold text-primary mb-3" style={{ borderBottom: '1px solid #eee', paddingBottom: '8px' }}>Subscription Details</h6>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="payment_term" className="form-label" style={{ fontSize: "13px" }}>Payment Term</label>
                                                            <select
                                                                name="payment_term" className="form-control form-feild" value={formData.payment_term} onChange={handleChange}
                                                                style={{ border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="yearly">Yearly</option>
                                                                <option value="half-yearly">Half Yearly</option>
                                                                <option value="quarterly">Quarterly</option>
                                                                <option value="custom">Custom</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="subscription_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.subscription_start_date ? dayjs(formData.subscription_start_date) : null}
                                                                    onChange={(date) => handleDateChange('subscription_start_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="vendor_subscription_end_dates" className="form-label d-block" style={{ fontSize: "13px" }}>End Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.vendor_subscription_end_dates ? dayjs(formData.vendor_subscription_end_dates) : null}
                                                                    onChange={(date) => handleDateChange('vendor_subscription_end_dates', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="subscription_due_date" className="form-label d-block" style={{ fontSize: "13px" }}>Due Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.subscription_due_date ? dayjs(formData.subscription_due_date) : null}
                                                                    onChange={(date) => handleDateChange('subscription_due_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Deployment Details Section */}
                                            <div className="mb-4">
                                                <h6 className="fw-semibold text-primary mb-3" style={{ borderBottom: '1px solid #eee', paddingBottom: '8px' }}>Deployment Details</h6>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="deployment_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.deployment_start_date ? dayjs(formData.deployment_start_date) : null}
                                                                    onChange={(date) => handleDateChange('deployment_start_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="deployment_end_date" className="form-label d-block" style={{ fontSize: "13px" }}>Deployment End</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.deployment_end_date ? dayjs(formData.deployment_end_date) : null}
                                                                    onChange={(date) => handleDateChange('deployment_end_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {/* Example Input Field */}
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="name" className="form-label" style={{ fontSize: '13px' }}>{isSalesOrderList ? 'Project Name' : 'Name'}</label>
                                                    <input
                                                        style={{
                                                            maxWidth: '280px',
                                                            border: '0.5px solid rgb(232, 233, 237)',
                                                            borderRadius: '14px',
                                                            ...(isLimitedEdit
                                                                ? { backgroundColor: "#ffffff", cursor: "not-allowed" }
                                                                : {})
                                                        }}
                                                        name="name"
                                                        id="name"
                                                        type="text"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        className={`form-control form-feild ${errors?.name ? 'is-invalid' : ''}`}
                                                    />

                                                    {errors.name && (
                                                        <div className="invalid-feedback" style={{ fontSize: '12px' }}>
                                                            *{errors.name}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="organisation_id" className="form-label" style={{ fontSize: '13px' }}>{isSalesOrderList ? 'Client Name' : 'Organisation Name'}:</label>
                                                    <CreatableSelect
                                                        isClearable
                                                        options={[
                                                            { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
                                                            ...organisations.map(org => ({ value: org.id, label: org.name || org.company_name || org.first_name || "" }))
                                                        ]}
                                                        value={
                                                            formData.organisation_id
                                                                ? {
                                                                    value: formData.organisation_id,
                                                                    label: organisations.find(org => String(org.id) === String(formData.organisation_id))?.name ||
                                                                        organisations.find(org => String(org.id) === String(formData.organisation_id))?.company_name ||
                                                                        organisations.find(org => String(org.id) === String(formData.organisation_id))?.first_name || ""
                                                                }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            if (!selectedOption) {
                                                                setFormData(prev => ({ ...prev, organisation_id: '', contact_id: '' }));
                                                                return;
                                                            }
                                                            if (selectedOption.value === "create_new") {
                                                                setIsLeadModalHidden(true);
                                                                setShowOrgModal(true);
                                                                return;
                                                            }
                                                            
                                                            const orgId = selectedOption.value;
                                                            setFormData(prev => ({ 
                                                                ...prev, 
                                                                organisation_id: orgId
                                                            }));
                                                        }}
                                                        placeholder="Select"
                                                    />
                                                </div>
                                            </div>
                                            {!isSalesOrderList && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="customer_type" className="form-label" style={{ fontSize: '13px' }}>Customer Type:</label>
                                                        <select
                                                            style={{
                                                                maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px', ...(isLimitedEdit
                                                                    ? { backgroundColor: "#ffffff", cursor: "not-allowed" }
                                                                    : {})
                                                            }}
                                                            name="customer_type"
                                                            id="customer_type"
                                                            className="form-control form-feild"
                                                            value={formData.customer_type}
                                                            onChange={handleChange}
                                                            disabled={isLimitedEdit}
                                                        >
                                                            <option value="">Select </option>
                                                            <option value="existing customer">Existing Customer </option>
                                                            <option value="new customer">New Customer </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            )}
                                            {!isSalesOrderList && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="lead_source" className="form-label" style={{ fontSize: '13px' }}>Lead Source:</label>
                                                        <select
                                                            style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            name="lead_source"
                                                            id="lead_source"
                                                            className="form-control form-feild"
                                                            value={formData.lead_source}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select </option>
                                                            <option value="partner">Partner </option>
                                                            <option value="consultant">Consultant </option>
                                                            <option value="inside sales">Inside Sales </option>
                                                            <option value="sales generated">Sales Generated </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Partner selection - shown when lead_source = partner OR transaction_type = partner */}
                                            {(formData.lead_source === 'partner' || formData.transaction_type === 'partner') && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="partner_id" className="form-label" style={{ fontSize: '13px' }}>
                                                            Partner Name: <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            name="partner_id"
                                                            id="partner_id"
                                                            value={formData.partner_id}
                                                            onChange={handleChange}
                                                            className='form-control form-feild'
                                                        >
                                                            <option value="">Select a Partner</option>
                                                            {partnerOrganisations.map(org => (
                                                                <option key={org.id} value={org.id}>
                                                                    {org.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Transaction Type - standalone field */}
                                            {!isSalesOrderList && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="transaction_type" className="form-label" style={{ fontSize: '13px' }}>Transaction Type:</label>
                                                        <select
                                                            style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            name="transaction_type"
                                                            id="transaction_type"
                                                            value={formData.transaction_type}
                                                            onChange={(e) => {
                                                                const newType = e.target.value;
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    transaction_type: newType,
                                                                    // Clear margin when not margin_based type
                                                                    ...(newType !== 'margin_based' ? { margin_percentage: '' } : {}),
                                                                }));
                                                                if (errors.transaction_type) {
                                                                    setErrors(prev => ({ ...prev, transaction_type: undefined }));
                                                                }
                                                            }}
                                                            className='form-control form-feild'
                                                        >
                                                            <option value="">Select Type</option>
                                                            <option value="direct">Direct</option>
                                                            <option value="partner">Partner</option>
                                                            <option value="margin_based">Margin Based</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Margin Percentage - shown when transaction_type = margin_based */}
                                            {formData.transaction_type === 'margin_based' && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="margin_percentage" className="form-label" style={{ fontSize: '13px' }}>Margin (%):</label>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            step="0.01"
                                                            style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            name="margin_percentage"
                                                            id="margin_percentage"
                                                            className="form-control form-feild"
                                                            value={formData.margin_percentage}
                                                            onChange={handleChange}
                                                            placeholder="e.g. 15"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {['consultant', 'inside sales', 'sales generated'].includes(formData.lead_source) && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="type_id" className="form-label" style={{ fontSize: '13px' }}>
                                                            {formData.lead_source === 'consultant' ? 'Consultant Name' :
                                                                formData.lead_source === 'inside sales' ? 'Select Inside Sales' :
                                                                    ' Select Sales Generated'}
                                                        </label>
                                                        <select
                                                            style={{
                                                                maxWidth: '280px',
                                                                border: '0.5px solid rgb(232, 233, 237)',
                                                                borderRadius: '14px',
                                                            }}
                                                            name="type_id"
                                                            id="type_id"
                                                            value={formData.type_id}
                                                            onChange={handleChange}
                                                            className="form-control form-feild"
                                                        >
                                                            <option value="">Select</option>
                                                            {filteredContacts.map(contact => (
                                                                <option key={contact.id} value={contact.id}>
                                                                    {contact.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="stage" className="form-label" style={{ fontSize: '13px' }}>Stage:</label>
                                                    <select
                                                        style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                        name="stage"
                                                        id="stage"
                                                        className={`form-control form-feild ${errors?.stage ? 'is-invalid' : ''}`}
                                                        value={formData.stage}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select </option>
                                                        <option value="suspect">Suspect </option>
                                                        <option value="prospect">Prospect </option>
                                                        <option value="approach">Approach </option>
                                                        <option value="negotiation">Negotiation </option>
                                                        <option value="closed won">Closed Won </option>
                                                        <option value="closed lost">Closed Lost </option>
                                                        <option value="closed dead">Closed Dead </option>
                                                        <option value="order">Order </option>
                                                    </select>
                                                    {errors.stage && (
                                                        <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
                                                            *{errors.stage}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {!isSalesOrderList && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="probability" className="form-label" style={{ fontSize: '13px' }}>Probability(%):</label>
                                                        <input
                                                            style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                            name="probability"
                                                            id="probability"
                                                            className="form-control form-feild"
                                                            value={formData.probability !== '' ? formData.probability : '0'}
                                                            onChange={handleChange}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="value" className="form-label" style={{ fontSize: '13px' }}>
                                                        Value ({(formData.lead_source === 'partner' && formData.transaction_type === 'partner') ? 
                                                            (organisations.find(o => String(o.id) === String(formData.partner_id))?.currency || 'AED') : 
                                                            (organisations.find(o => String(o.id) === String(formData.organisation_id))?.currency || 'AED')})
                                                    </label>
                                                    <input
                                                        style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                        name="value"
                                                        id="value"
                                                        className='form-control form-feild'
                                                        value={formData.value}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>

                                            {!isSalesOrderList && (
                                                <>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="expected_revenue" className="form-label" style={{ fontSize: '13px' }}>
                                                                Expected Revenue ({(formData.lead_source === 'partner' && formData.transaction_type === 'partner') ? 
                                                                    (organisations.find(o => String(o.id) === String(formData.partner_id))?.currency || 'AED') : 
                                                                    (organisations.find(o => String(o.id) === String(formData.organisation_id))?.currency || 'AED')}):
                                                            </label>
                                                            <input
                                                                style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                                name="expected_revenue"
                                                                id="expected_revenue"
                                                                className="form-control form-feild"
                                                                value={formData.expected_revenue}
                                                                onChange={handleChange}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="products" className="form-label" style={{ fontSize: '13px' }}>Product:</label>
                                                            <CreatableSelect
                                                                isMulti
                                                                isClearable
                                                                options={[
                                                                    { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
                                                                    ...allProducts.map(product => ({
                                                                        value: product.id,
                                                                        label: product.product_name
                                                                    }))
                                                                ]}
                                                                value={formData.products.map(p => ({
                                                                    value: p.product_id,
                                                                    item_name: p.item_name
                                                                }))}
                                                                onChange={(selectedOptions) => {
                                                                    if (!selectedOptions || selectedOptions.length === 0) {
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            products: []
                                                                        }));
                                                                        return;
                                                                    }
                                                                    const containsNewProduct = selectedOptions.some(option => option.value === "create_new");
                                                                    console.log("Contains 'Add New' Option:", containsNewProduct);
                                                                    if (containsNewProduct) {
                                                                        console.log("Opening Product Form Modal");
                                                                        setIsLeadModalHidden(true);
                                                                        setShowProductModal(true);
                                                                    } else {
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            products: selectedOptions.map(option => ({
                                                                                product_id: option.value,
                                                                                item_name: option.label,
                                                                                item_description: allProducts.find(p => p.id === option.value)?.description || '',
                                                                                quantity: 1,
                                                                                price: allProducts.find(p => p.id === option.value)?.price || ''
                                                                            }))
                                                                        }));
                                                                    }
                                                                }}
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    control: (provided, state) => ({
                                                                        ...provided,
                                                                        fontSize: '14px',
                                                                        borderRadius: '14px',
                                                                        minHeight: '39px',
                                                                        border: '0.5px solid rgb(232, 233, 237)',
                                                                        flexWrap: 'wrap',
                                                                        overflow: 'auto',
                                                                        maxHeight: state.hasValue ? 'auto' : '39px',
                                                                    }),
                                                                    valueContainer: (provided) => ({
                                                                        ...provided,
                                                                        flexWrap: 'wrap',
                                                                        maxHeight: '100px',
                                                                        overflowY: 'auto',
                                                                    }),
                                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                                                }}
                                                            />
                                                        </div>
                                                    </div> */}

                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="brand_id" className="form-label" style={{ fontSize: '13px' }}>
                                                                Brand:
                                                            </label>
                                                            <Select
                                                                isMulti
                                                                name="brand_id"
                                                                options={brands?.map((brand) => ({
                                                                    value: brand.id,
                                                                    label: brand.name,
                                                                })) || []}
                                                                value={((brands || []))?.filter((brand) =>
                                                                    (formData.brand_id || []).some(bid => String(bid) === String(brand.id))
                                                                ).map((brand) => ({
                                                                    value: brand.id,
                                                                    label: brand.name,
                                                                }))}
                                                                onChange={(selectedOptions) => {
                                                                    setFormData({
                                                                        ...formData,
                                                                        brand_id: selectedOptions.map((option) => option.value),
                                                                    });
                                                                }}
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                                styles={{
                                                                    control: (provided) => ({
                                                                        ...provided,
                                                                        fontSize: '14px',
                                                                        maxWidth: '280px',
                                                                        borderRadius: '14px',
                                                                        height: '39px',
                                                                        border: '0.5px solid rgb(232, 233, 237)',
                                                                    }),
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="closed_date" className="form-label d-block" style={{ fontSize: '13px' }}>Expected Closed Date:</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.closed_date ? dayjs(formData.closed_date) : null}
                                                                    onChange={(date) => handleDateChange('closed_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="next_steps" className="form-label" style={{ fontSize: '13px' }}>Next Step:</label>
                                                            <input
                                                                style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                                name="next_steps"
                                                                id="next_steps"
                                                                type='text'
                                                                className="form-control form-feild"
                                                                value={formData.next_steps}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="remarks" className="form-label" style={{ fontSize: '13px' }}>Remarks:</label>
                                                            <textarea
                                                                style={{ maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px' }}
                                                                name="remarks"
                                                                id="remarks"
                                                                className="form-control form-feild"
                                                                value={formData.remarks}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {(isOrdersPage && dealData && dealData.id) && (
                                                <div className="col-md-6">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="revenue_type" className="form-label" style={{ fontSize: "13px" }}>WHT(%)</label>
                                                        <input
                                                            type="text"
                                                            name="WHT"
                                                            className="form-control form-feild"
                                                            value={formData.WHT}
                                                            onChange={handleChange}
                                                            style={{
                                                                maxWidth: '280px', border: '0.5px solid rgb(232, 233, 237)', borderRadius: '14px',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {(isOrdersPage && dealData && dealData.id && revenueType === 'subscription') && (
                                                <>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="payment_term" className="form-label" style={{ fontSize: "13px" }}>Payment Term</label>
                                                            <select
                                                                name="payment_term"
                                                                id="payment_term"
                                                                className="form-control"
                                                                value={formData.payment_term}
                                                                onChange={handleChange}
                                                                style={{
                                                                    fontSize: '13px',
                                                                    maxWidth: '280px',
                                                                    borderRadius: '14px',
                                                                    height: '35px',
                                                                    border: '0.5px solid rgb(232, 233, 237)'
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="yearly">Yearly</option>
                                                                <option value="half-yearly">Half Yearly</option>
                                                                <option value="quarterly">Quarterly</option>
                                                                <option value="custom">Custom</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="subscription_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.subscription_start_date ? dayjs(formData.subscription_start_date) : null}
                                                                    onChange={(date) => handleDateChange('subscription_start_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="vendor_subscription_end_dates" className="form-label d-block" style={{ fontSize: "13px" }}>End Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.vendor_subscription_end_dates ? dayjs(formData.vendor_subscription_end_dates) : null}
                                                                    onChange={(date) => handleDateChange('vendor_subscription_end_dates', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="subscription_due_date" className="form-label d-block" style={{ fontSize: "13px" }}>Due Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.subscription_due_date ? dayjs(formData.subscription_due_date) : null}
                                                                    onChange={(date) => handleDateChange('subscription_due_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {revenueType === 'deployment' && isOrdersPage && dealData && dealData.id && (
                                                <>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="deployment_start_date" className="form-label d-block" style={{ fontSize: "13px" }}>Start Date</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.deployment_start_date ? dayjs(formData.deployment_start_date) : null}
                                                                    onChange={(date) => handleDateChange('deployment_start_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="deployment_end_date" className="form-label d-block" style={{ fontSize: "13px" }}>Deployment End</label>
                                                            <div className="datepicker-wrapper w-280">
                                                                <DatePicker
                                                                    format="DD-MM-YYYY"
                                                                    value={formData.deployment_end_date ? dayjs(formData.deployment_end_date) : null}
                                                                    onChange={(date) => handleDateChange('deployment_end_date', date)}
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            size: "small",
                                                                            sx: { "& .MuiOutlinedInput-root": { height: "39px", fontSize: "13px" } }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </LocalizationProvider>
                        </form>
                    </Offcanvas.Body>

                    <div className="p-3 d-flex justify-content-end border-top">
                        <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                            Close
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                            Save
                        </button>
                    </div>
                </Offcanvas>
            )}

            {showOrgModal && (
                <OrganisationModal
                    showModal={showOrgModal}
                    handleClose={handleOrgModalClose}
                    fetchIndustries={fetchIndustries}
                    industries={industries}
                    addOrg={addOrganisation}
                />
            )}
            {showProductModal && (
                <ProductForm
                    showModal={showProductModal}
                    handleClose={handleProductModalClose}
                    categories={categories}
                    fetchCategories={fetchCategories}
                    addProduct={addProducts}
                    fetchBrands={fetchBrands}
                    brands={brands}
                    vendors={vendors}
                    fetchVendors={fetchVendors}
                />
            )}
        </div>
    );
};

export default DealModal;
